module.exports = __webpack_public_path__ + "static/media/red-next-arrow.0bb20a39.svg";